__webpack_require__.p = "/edp/life/";